export enum EnvironmentValues {
  LOCAL = 'LOCAL',
  DEV = 'DEV',
  PROD = 'PROD',
}
